import { notification } from 'antd';

import { gwGet, gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';
import { setProducts } from '../load';

const ERROR_NOTIFICATION_SHOW_SECS = 10;
const { GET_USER_ASSET_API } = API_PATH;
const {
  FETCH_USER_TRADE_FEE,
  SET_USER_TRADE_FEE,
  SET_CURRENCY_RATE_DATA,
  FETCH_CURRENCY_RATE_DATA,
  FETCH_USER_TRADE_FEE_ERROR,
  FETCH_CURRENCY_RATE_DATA_ERROR,
  SET_ALL_USER_ASSETS,
  SET_USER_ASSETS,
  SET_ALL_USER_ASSETS_BTC_VALUES,
  FETCH_FAVORITES_DATA,
  SET_FAVORITES_DATA,
  SET_FETCH_COMPLETED,
  FETCH_FAVORITES_DATA_ERROR,
  HANDLE_FAVORITE_DATA_SUCCESS,
  HANDLE_FAVORITE_DATA_FAILED,
  SET_TOP_MOVERS,
} = actionTypes;

const setUserTradeFee = createBaseActions(SET_USER_TRADE_FEE, 'data');
const setCurrencyRate = createBaseActions(SET_CURRENCY_RATE_DATA, 'data');
const setAllUserAssetsData = createBaseActions(SET_ALL_USER_ASSETS, 'data');
const setUserAssetsData = createBaseActions(SET_USER_ASSETS, 'data');
const setUserBtcValuationData = createBaseActions(SET_ALL_USER_ASSETS_BTC_VALUES, 'data');
const sendUserAssetPost = (locale, data) => gwPost(GET_USER_ASSET_API, data);
const setFavoritesData = createBaseActions(SET_FAVORITES_DATA, 'data');
const setFetchCompleted = createBaseActions(SET_FETCH_COMPLETED, 'data');
const handleFavoriteDataSuccess = createBaseActions(HANDLE_FAVORITE_DATA_SUCCESS, 'result');
const handleFavoriteDataError = createBaseActions(HANDLE_FAVORITE_DATA_FAILED, 'reason');

const setTopMoversArray = createBaseActions(SET_TOP_MOVERS, 'data');

export const fetchUserTradeFee = (symbol, locale) => async (dispatch) => {
  dispatch({ type: FETCH_USER_TRADE_FEE });
  try {
    const userTradeFee = await gwGet(`${API_PATH.USER_TRADE_FEE_API_PATH}?symbol=${symbol}`, {
      locale,
    });
    dispatch(setUserTradeFee(handleGwData(userTradeFee)));
  } catch (error) {
    dispatch({ type: FETCH_USER_TRADE_FEE_ERROR, error });
  }
};

export const fetchCurrencyRate = () => async (dispatch) => {
  dispatch({ type: FETCH_CURRENCY_RATE_DATA });
  try {
    const rate = await gwGet(API_PATH.CURRENCY_RATE_API_PATH);
    dispatch(setCurrencyRate(handleGwData(rate)));
  } catch (error) {
    dispatch({ type: FETCH_CURRENCY_RATE_DATA_ERROR, error });
  }
};

export const getProductsRequest = (req) => gwGet(API_PATH.PRODUCTS_API_PATH, req);

export const getProducts = async (req) => {
  let result = [];
  try {
    result = await makeOrCacheApiReq(
      API_PATH.PRODUCTS_API_PATH,
      () => getProductsRequest(req),
      (res) => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
  return result;
};

export const fetchAllUserAssets = (locale) => async (dispatch) => {
  let userAsset = await sendUserAssetPost(locale);
  userAsset = handleGwData(userAsset);
  dispatch(setAllUserAssetsData(userAsset));
};

export const fetchUserAssets = (assets, locale) => async (dispatch) => {
  const queryAssets = [...assets];
  const useAssets = {};
  const promises = [];
  const sendPost = (asset) => sendUserAssetPost(locale, { asset });
  if (!queryAssets.includes('BNB')) {
    queryAssets.push('BNB');
  }
  queryAssets.forEach((asset) => promises.push(sendPost(asset)));

  const res = await Promise.all(promises);
  res.forEach((assetInfo) => {
    if (Array.isArray(handleGwData(assetInfo))) {
      const { asset, free } = handleGwData(assetInfo)[0];
      useAssets[asset] = free;
    }
  });
  dispatch(setUserAssetsData(useAssets));
};

export const getUserBtcValuation = () => async (dispatch) => {
  let userAllAsset = await gwPost(API_PATH.GET_USER_BTC_VALUATION_API, {});
  userAllAsset = handleGwData(userAllAsset) || {};
  dispatch(setUserBtcValuationData(userAllAsset));
};

export const setInitFavorite = () => (dispatch, getState) => {
  const { isLoggedIn } = getState();
  if (isLoggedIn || typeof window === 'undefined' || !window.localStorage) return;

  let favorites = window.localStorage.getItem('favorites') || null;
  try {
    favorites = JSON.parse(favorites) || [];
    dispatch(setFavoritesData(favorites));
  } catch (error) {
    bog.error(`Error: init Favorite - val is ${favorites}, ${error ? error && error.message : ''}`);
  }
};

export const fetchFavoritesData = () => async (dispatch) => {
  dispatch({ type: FETCH_FAVORITES_DATA });
  try {
    let favorites = await gwPost(API_PATH.FAVORITES_API_PATH, {});
    favorites = handleGwData(favorites) || [];
    dispatch(setFavoritesData(favorites));
    dispatch(setFetchCompleted(true));
  } catch (error) {
    dispatch({ type: FETCH_FAVORITES_DATA_ERROR, error });
  }
};

export const fetchProductData = () => async (dispatch) => {
  try {
    const products = await gwGet(API_PATH.PRODUCTS_API_PATH);
    dispatch(setProducts(handleGwData(products)));
  } catch (error) {
    bog.error(`Error: getProducts error, message is ${error.message}`);
  }
};

export const getTopMovesList = () => async (dispatch) => {
  try {
    const data = await gwGet(API_PATH.GET_KLINE_LIST);
    //mock data
    // const data = {
    //   code: '000000',
    //   message: null,
    //   messageDetail: null,
    //   data: [
    //     {
    //       assetCode: 'WAVES',
    //       logoUrl:
    //         'https://static.binance.us/image/admin_mgs_image_upload/20210202/b5fa54f3-2621-475b-bd49-3fcf2ae59074.png',
    //       sequence: 1,
    //       svgUrl:
    //         'https://static.qa1fdg.net/image/kline/LTCUSD@token-top-movers.svg?time=1636098057000',
    //       closePrice: 25.4006,
    //       percentage: 4.86,
    //       enableOcbs: true,
    //       enableTrading: true
    //     },
    //     {
    //       assetCode: 'XTZ',
    //       logoUrl:
    //         'https://static.binance.us/image/admin_mgs_image_upload/20210202/81291508-f5c9-4cb7-a8c3-802c822e2d0e.png',
    //       sequence: 0,
    //       svgUrl:
    //         'https://static.qa1fdg.net/image/kline/LTCUSD@token-top-movers.svg?time=1636098057000',
    //       closePrice: 6.3176,
    //       percentage: 9.87,
    //       enableOcbs: true,
    //       enableTrading: true
    //     },
    //     {
    //       assetCode: 'MKR',
    //       logoUrl:
    //         'https://static.binance.us/image/admin_mgs_image_upload/20210202/f5d7e348-b424-4d18-a651-3c769c4ca18f.png',
    //       sequence: 2,
    //       svgUrl:
    //         'https://static.qa1fdg.net/image/kline/LTCUSD@token-top-movers.svg?time=1636098057000',
    //       closePrice: 2265.4339,
    //       percentage: -9.53,
    //       enableOcbs: true,
    //       enableTrading: true
    //     },
    //     {
    //       assetCode: 'FIL',
    //       logoUrl:
    //         'https://static.binance.us/image/admin_mgs_image_upload/20210608/dfca71f8-4b9b-45a6-b80f-6c8cf528ccc9.png',
    //       sequence: 3,
    //       svgUrl:
    //         'https://static.qa1fdg.net/image/kline/LTCUSD@token-top-movers.svg?time=1636098057000',
    //       closePrice: 64.08,
    //       percentage: -12.44,
    //       enableOcbs: true,
    //       enableTrading: true

    //     },
    //   ],
    //   success: true,
    // }
    if (data.success) {
      const topMoversList = data?.data || [];
      const topMovers = topMoversList.map((item) => {
        if (item?.svgUrl) {
          item.svgUrl = `${item?.svgUrl}?time=${Date.parse(new Date())}`;
        }
        return item;
      });
      dispatch(setTopMoversArray(topMovers));
    }
  } catch (error) {
    console.log(JSON.stringify(error));
  }
};

export const handleFavorite = (symbol) => async (dispatch, getState) => {
  const { isLoggedIn, locale, localeData, favorites = [] } = getState();
  const i18n = localeData[locale];
  let url;
  let params = { symbol };
  const _favorites = favorites.slice();
  const index = _favorites.indexOf(symbol);
  if (index > -1) {
    _favorites.splice(index, 1);
    url = API_PATH.DELETE_FAVORITE_DATA_API_PATH;
    params = { symbols: [symbol] };
  } else {
    _favorites.push(symbol);
    url = API_PATH.ADD_FAVORITE_DATA_API_PATH;
  }

  dispatch(setFavoritesData(_favorites));

  if (isLoggedIn) {
    try {
      let result = await gwPost(url, params);
      result = handleGwData(result);
      dispatch(handleFavoriteDataSuccess(result));
    } catch (error) {
      bog.error(`Error: favorite Data - ${error ? error && error.message : ''}`);
      notification.error({
        message: i18n.failed || 'Favorite Data Error',
        description: error ? error && error.message : '',
        duration: ERROR_NOTIFICATION_SHOW_SECS,
      });
      dispatch(handleFavoriteDataError(error));
    }
  } else {
    window.localStorage && window.localStorage.setItem('favorites', JSON.stringify(_favorites));
  }
};
